// synced from loomweb blocks/knowledge-query-block-view.tsx (de-Tailwind'd).
/**
 * Knowledge-query block. Faithful to loomweb's KnowledgeQueryBlockView: header
 * (icon + "Knowledge Query" + the knowledge name + in-progress / Done state), an
 * optional active-text row, and the query. Tailwind classes are replaced by
 * namespaced `replay-*` CSS; lucide icons by the local inline-SVG set.
 */
import type { JSX } from "react";
import type { KnowledgeQueryBlock } from "@shared/loom-message-block";
import { BookOpenIcon, LoaderIcon, CheckIcon } from "./icons";

export function KnowledgeQueryBlockView({ block }: { block: KnowledgeQueryBlock }): JSX.Element {
  const isInProgress = block.status === "in_progress" || block.status === "streaming";
  const isCompleted = block.status === "completed";

  return (
    <div className="replay-block replay-knowledge-query-block">
      <div className="replay-block-head">
        <BookOpenIcon className="replay-icon replay-text-purple" />
        <span className="replay-block-label">Knowledge Query</span>
        <span className="replay-kq-name">{block.knowledgeName}</span>
        {isInProgress && (
          <span className="replay-block-flag replay-text-primary">
            <LoaderIcon className="replay-icon-xs replay-spin" />
          </span>
        )}
        {isCompleted && (
          <span className="replay-block-flag replay-text-success">
            <CheckIcon className="replay-icon-xs" />
            Done
          </span>
        )}
      </div>

      {isInProgress && block.activeText !== undefined && block.activeText.length > 0 && (
        <div className="replay-block-active">{block.activeText}</div>
      )}

      <div className="replay-query-body">
        <span className="replay-text-muted replay-mr-1">Query:</span>
        {block.query}
      </div>
    </div>
  );
}
